import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RightbarContent = _resolveComponent("RightbarContent")
  const _component_Collapse = _resolveComponent("Collapse")

  return (_ctx.$responsive.desktop)
    ? (_openBlock(), _createBlock(_component_Collapse, {
        key: 0,
        open: !!$props.view,
        horizontal: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_RightbarContent, {
            data: $props.data,
            view: $props.view,
            onClose: $options.close
          }, null, 8 /* PROPS */, ["data", "view", "onClose"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["open"]))
    : (_openBlock(), _createBlock(_Transition, {
        key: 1,
        name: "rightbar-mobile"
      }, {
        default: _withCtx(() => [
          ($props.view)
            ? (_openBlock(), _createBlock(_component_RightbarContent, {
                key: 0,
                class: "rightbar-container",
                data: $props.data,
                view: $props.view,
                onClose: $options.close
              }, null, 8 /* PROPS */, ["data", "view", "onClose"]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }))
}